(async () => {
    const { Core } = await importModule('Core');

    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_BELONGS_FORM = 'form-child';

    customElements.define('product-to-cart', class extends Core {
        elements = {
            button: '[data-to-cart]'
        }

        subscriptions = {
            'cart:update': '_cartUpdateHandler',
            'cart:error': '_cartUpdateHandler'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
            this._timeouts = [];
            this._handleClick()
        }

        disconnectedCallback() {
            // Clear any pending timeouts to prevent memory leaks
            if (this._timeouts) {
                this._timeouts.forEach(timeout => clearTimeout(timeout));
                this._timeouts = [];
            }
        }

        _handleClick() {
            this.addEventListener('click', this._onClick.bind(this))
        }

        _onClick(e) {
            e.preventDefault();
            if (this._isAdding) return;
            
            // Store original button content before changing it
            const $btn = this.$button;
            const counter = $btn.querySelector('buy-with-counter');
            
            // For buttons with buy-with-counter, find the active span and store its HTML
            if (counter) {
                const activeSpan = counter.querySelector('[data-element="add-many"]:not([hidden])') || 
                                  counter.querySelector('[data-element="add-one"]:not([hidden])');
                if (activeSpan) {
                    this._originalButtonHTML = activeSpan.innerHTML;
                    this._targetElement = activeSpan;
                } else {
                    // Fallback if spans not found
                    this._originalButtonHTML = counter.innerHTML;
                    this._targetElement = counter;
                }
            } else {
                // For buttons without buy-with-counter, use button directly
                this._originalButtonHTML = $btn.innerHTML;
                this._targetElement = $btn;
            }
            
            // Show Adding
            if (this._targetElement) {
                this._targetElement.textContent = 'Adding';
            }
            
            this.$button.disabled = true;
            this.$button.classList.add('adding-state');
            this._isAdding = true;
            this._hasHandledUpdate = false;
            
            this.addToCart(this.belongsToForm ? this.getFormItems() : this.cartItem);
        }

        addToCart(items) {
            this.publish('cart:add', {
                items
            });
        }

        _cartUpdateHandler(data) {
            if (!this._isAdding) return;
            
            // Prevent handling the same update multiple times
            if (this._hasHandledUpdate) return;
            
            const isSuccessfulUpdate = data && (data.cart || data.meta);

            if (isSuccessfulUpdate) {
                this._hasHandledUpdate = true;
                
                // On success, show Added
                const counter = this.querySelector('buy-with-counter');
                if (counter && typeof counter.setFeedback === 'function') {
                    // Pass the original HTML and a callback to re-enable button when text is restored
                    counter.setFeedback(this._originalButtonHTML, () => {
                        this._reEnableButton();
                    });
                } else if (this._targetElement && this._originalButtonHTML) {
                    // Show Added for buttons without buy-with-counter
                    this._targetElement.textContent = 'Added';
                    const timeout1 = setTimeout(() => {
                        // Restore original content after 1 second and re-enable button
                        if (this._targetElement && this._originalButtonHTML) {
                            this._targetElement.innerHTML = this._originalButtonHTML;
                        }
                        this._reEnableButton();
                    }, 1000);
                    if (!this._timeouts) this._timeouts = [];
                    this._timeouts.push(timeout1);
                }
                
                // Clean up state after delay
                const timeout2 = setTimeout(() => {
                    this._cleanupState();
                }, 1500);
                if (!this._timeouts) this._timeouts = [];
                this._timeouts.push(timeout2);
            } else {
                // On error, restore original content immediately
                this._hasHandledUpdate = true;
                if (this._targetElement && this._originalButtonHTML) {
                    this._targetElement.innerHTML = this._originalButtonHTML;
                }
                // Reset button state immediately
                this._resetButtonState();
            }
        }

        _reEnableButton() {
            this.$button.disabled = false;
            this.$button.classList.remove('adding-state');
        }

        _cleanupState() {
            this._isAdding = false;
            this._hasHandledUpdate = false;
        }

        _resetButtonState() {
            this._reEnableButton();
            this._cleanupState();
            
            // Restore original content if still showing Adding
            if (this._targetElement && this._originalButtonHTML) {
                const currentText = this._targetElement.textContent.trim();
                if (currentText === 'Adding') {
                    this._targetElement.innerHTML = this._originalButtonHTML;
                }
            }
        }

        get belongsToForm() {
            return this.hasAttribute(ATTR_BELONGS_FORM)
        }

        getFormItems() {
            const productForm = this.closest('product-form');
            if (productForm && typeof productForm.cartItems !== 'undefined') {
                return productForm.cartItems;
            }
            return this.cartItem;
        }

        get quantity() {
            const form = this.closest('form');

            if (!form) return 1
            const formData = new FormData(form);
            const formQuantity = formData.get('quantity');
            return +formQuantity || 1;
        }

        get cartItem() {
            const variantId = +this.getAttribute(ATTR_VARIANT_ID);

            return [{
                id: variantId,
                quantity: this.quantity
            }];
        }

        set loading(state) {
            this.$button.classList.toggle(CN_LOADING, state);
        }

        get cartNotificationsEnabled() {
            return window.global.cartNotificationsEnabled;
        }

        set variantId(id) {
            this.setAttribute(ATTR_VARIANT_ID, id)
        }

    })
})();
